/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom powerpoint file icon.
 * @export
 */

export const CUSTOM_FILE_POWERPOINT_ICON = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.9393 3.23223L15.5878 3.58377L15.9393 3.23223C15.4705 2.76339 14.8346 2.5 14.1716 2.5H6C5.17157 2.5 4.5 3.17157 4.5 4V20C4.5 20.8284 5.17157 21.5 6 21.5H18C18.8284 21.5 19.5 20.8284 19.5 20V7.82843C19.5 7.16539 19.2366 6.5295 18.7678 6.06066L15.9393 3.23223Z"
      fill="#E7E7E7"
      stroke="#BCBCBC"
    />
    <path d="M14.5 3V6.5C14.5 7.05228 14.9477 7.5 15.5 7.5H19" stroke="#BCBCBC" />
    <rect fill="#E96900" height="12" rx="2" width="12" y="8" />
    <path d="M3.5 11.5V16.5" stroke="white" strokeLinecap="round" />
    <path
      d="M3.5 11.5H7C7.33333 11.5 8.5 11.5 8.5 13C8.5 14.5 7.33333 14.5 7 14.5H4"
      stroke="white"
      strokeLinecap="round"
    />
  </svg>
);
